import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findProvinceList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/student/selProvinceByUser', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  selProvinceByUserByAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/student/selProvinceByUserByAll', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  selectProvinceCondition({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/artUniversity/selectProvinceCondition', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getSubjectList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/artUniversity/getSubjectList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  selectUniversityList({ commit }, params){
    return new Promise((resolve, reject) => {
      axios.post('/artUniversity/selectUniversityList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getBatchNum({ commit }, params){
    return new Promise((resolve, reject) => {
      axios.post('/artUniversity/getBatchNum', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  selectSpecialityList({ commit }, params){
    return new Promise((resolve, reject) => {
      axios.post('/artUniversity/selectSpecialityList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  selectZjUniversityList({ commit }, params){
    return new Promise((resolve, reject) => {
      axios.post('/artUniversity/selectZjUniversityList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

}
